import { NextPageContext } from "next";

import { getRequestHeader } from "utils/requestContext";

import { AllActions } from "./rootReducer";

type ConfigState = {
  sso?: {
    signInUrlWithoutReturnUrl: string;
    signUpUrlWithoutReturnUrl: string;
    signOutUrlWithoutReturnUrl: string;
  };
  domainCountryCode: string;
};

export const initialState: ConfigState = { domainCountryCode: "US" };

// This is a special action that any reducer can respond to, similar to load cookies
export const LOAD_REQUEST_CONTEXT = "LOAD_REQUEST_CONTEXT";
export const SET_DOMAIN_LOCATION = "config/domain/set";

export type LoadRequestContextAction = {
  type: typeof LOAD_REQUEST_CONTEXT;
  context: NextPageContext;
};

export type SetDomainCountryCodeAction = {
  type: typeof SET_DOMAIN_LOCATION;
  countryCode: string;
};

export type ConfigActions =
  | LoadRequestContextAction
  | SetDomainCountryCodeAction;

const configReducer = (
  state = initialState,
  action: AllActions
): ConfigState => {
  switch (action.type) {
    case LOAD_REQUEST_CONTEXT:
      return {
        ...state,
        sso: {
          signInUrlWithoutReturnUrl:
            getRequestHeader(
              action.context,
              "x-leafly-sign-in-url",
              "https://sso-integration.leafly.io/sign-in"
            ) + "?rd=",
          signOutUrlWithoutReturnUrl:
            getRequestHeader(
              action.context,
              "x-leafly-sign-out-url",
              "https://sso-integration.leafly.io/sign-out"
            ) + "?rd=",
          signUpUrlWithoutReturnUrl:
            getRequestHeader(
              action.context,
              "x-leafly-sign-up-url",
              "https://sso-integration.leafly.io/sign-up"
            ) + "?rd=",
        },
      };
    case SET_DOMAIN_LOCATION:
      return {
        ...state,
        domainCountryCode: action.countryCode,
      };
    default:
      return state;
  }
};

export default configReducer;
